module.exports = __webpack_public_path__ + "static/home-design-magazine-jul-2011.a971fd08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/media/home-design-magazine-jul-2011.jpg
// module id = 466
// module chunks = 140328616742760